<template>
   <div class="sidebar-event tw-flex tw-w-full">
        <calendar-icon size="xs" :tEvent="tEvent" class="tw-self-start"></calendar-icon>
        <div class="tw-flex tw-flex-1 tw-flex-col tw-ml-4 tw-mb-6">
            <h4 v-line-clamp:21="2" class="event-title tw-relative tw-text-normal tw-font-bold tw-leading-normal tw-mb-2 hover:tw-underline" style>
                {{ tEvent.title }}
            </h4>
            <div class="tw-flex tw-items-center tw-text-lg">
                <div class="user-icon-previews event-members">
                    <template v-for="(member, index) in members">
                        <img :key="member.id" :src="member.user.avatar" onerror="this.src='/img/avatar.png'" v-if="index < 2">
                    </template>
                </div>
                <span class="tw-ml-1 tw-text-sm">{{ tEvent.members_count }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import CalendarIcon from '../CalendarIcon.vue';

export default {
    name: 'SidebarEvent',

    components: {
        'calendar-icon': CalendarIcon,
    },

    props: {
        tEvent: {
            required: true,
        },
    },

    computed: {
        members() {
            return this.tEvent.memberSelection.filter((member) => member.user != null);
        },
    },
};
</script>

<style lang="scss" scoped>
.sidebar-event {
    .event-title {
       @apply tw-break-normal #{!important};
    }
}
</style>
